module.exports = __webpack_public_path__ + "static/scale-model-of-jacksonville-zoo-and-gardens-in-jacksonville-florida-bdf85c1e8ca6048b553565c458d47f22.png";